export default {
    getGraduateResults (state) {
        return state.programmeResults.filter((x) => {
            if (x.LevelName === "Graduate"){
                //alert(x.ProgramsPlus)
                console.log(x)
                return x.ProgramsPlus
            }

        })
    }
    /*,
    doneTodos (state) {
        return state.todos.filter(todo => todo.done)
    }*/

}
